import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { brandFont } from 'components/layout/brand-font';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

const rootContainerStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 1rem;
  padding: 1rem;
  width: 100%;
  height: 132px;
  background-color: ${primitive.$white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
`;

export const ContainerDiv = styled.div`
  ${rootContainerStyles}
`;

export const ContainerLink = styled(Link)`
  ${rootContainerStyles}
  text-decoration: none;
  color: inherit;
`;

export const TitleAndDescriptionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
`;

export const Title = styled.h3`
  font: ${brandFont.headerTwo};
  margin: 0;
`;

export const DescriptionText = styled.p`
  font: ${brandFont.copyOne};
  margin: 0;
`;

export const DescriptionBlock = styled(SanityBlockRenderer)`
  font: ${brandFont.copyOne};
`;

export const StyledPicture = styled(Picture)`
  width: 100px;
  height: 100px;
`;
